import React, { useEffect, useState } from "react";
import { DrawerBody, DrawerHeader, DrawerHeaderTitle, OverlayDrawer } from "@fluentui/react-components/unstable";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { Button, Divider, DrawerFooter, FluentProvider, TabValue, webLightTheme } from "@fluentui/react-components";
import { TablistComponent } from "../tab_list/tablist.component";
import { Stack, StackItem } from "@fluentui/react"
import { validation } from "../../utility/validation";
import { dashboardTheme, overlayHeight, overlayWidth, paddingBottom } from "../../styles/customStyles";

/** @NOTE : Check the new comment field for a new faeture */

type dataProps = {
  overlayopen: boolean | undefined;
  setOverlayOpen?: (arg0: boolean) => void;
  overlayData: any;
  saveBtnFunc?: any;
  isNavBtn?: any;
  formRef?: any
  handleOutsideButton?: any
  handleSubmit?: any
  classificationNameValidation?: boolean
  pagename?: string;
  saveBtnClicked?: boolean;
  isDisabled?: boolean;
}

const OverLay = (props: dataProps) => {

  // var tabItems: any = ["Intro", "Basic"];
  const [activeTab, setActiveTab] = React.useState<TabValue>("tab1");
  const [selectedValue, setSelectedValue] = React.useState<TabValue>("tab1");
  // const [showWarning, setShowWarning] = useState(false);
  const [hover, setHover] = useState(false);


  useEffect(() => {
    const elements = document.querySelectorAll('[id*="_title"]');
    elements.forEach(elementa => {
      (elementa as HTMLElement).style.fontSize = '20px';
    });
  }, [activeTab, props.overlayData]);

  useEffect(() => {
    changeSVGPathD();
  }, [activeTab, props.overlayData])

  useEffect(() => {
    if (props.overlayopen) {
      sessionStorage.setItem("overlayStatus", `${true}`);
    } else {
      sessionStorage.removeItem("overlayStatus");
    }
  }, [props.overlayopen])

  function changeSVGPathD() {
    const newPathD = "M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.12 4.13a.5.5 0 0 1-.63.76l-.07-.06-4.13-4.12A5.5 5.5 0 1 1 8.5 3Zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z";

    // Select all path elements within the SVG in the specified span within the div
    const pathElements = document.querySelectorAll('#multistring path');
    console.log("pathElements", pathElements)

    // Update the d attribute of each path element
    pathElements.forEach(path => {
      path.setAttribute('d', newPathD);
    });
  }

  // Call the function to change the path d value



  function handleFormSubmit(formId: string, e: React.FormEvent<HTMLButtonElement>) {
    const form = document.getElementById(formId);
    if (!form) return false;
    const requiredFields = form.querySelectorAll("[required]");
    const requiredDropdownFields = Array.from(form.querySelectorAll("[aria-required]"))
      .filter(field => field.getAttribute("aria-required") === "true");
    var isEmpty = Array.from(requiredFields).some(field => (field as HTMLInputElement).value.trim() === "");
    isEmpty = isEmpty !== true ? Array.from(requiredDropdownFields).some(field => (field as HTMLInputElement).value.trim() === "") : isEmpty;
    // setShowWarning(isEmpty);
    return isEmpty ? false : (handleNextBtnClick(e), true);
  }

  // Usage example: // var isFormValid = somefunction();
  function somefunction(e: React.FormEvent<HTMLButtonElement>) {
    return handleFormSubmit("myForm", e)
  }

  function somefunction1(e: React.FormEvent<HTMLButtonElement>) {
    return handleFormSubmit("myFormAppmonitored", e)
  }

  function somefunction2(e: React.FormEvent<HTMLButtonElement>) {
    return handleFormSubmit("myFormSelfhelp", e)
  }

  function somefunction3(e: React.FormEvent<HTMLButtonElement>) {
    return handleFormSubmit("myFormAutoheal", e)
  }

  function somefunction4(e: React.FormEvent<HTMLButtonElement>) {
    return handleFormSubmit("myFormAutomationschedule", e)
  }

  function somefunction5(e: React.FormEvent<HTMLButtonElement>) {
    return handleFormSubmit("myFormUsersurvey", e)
  }

  const handleNextBtnClick = async (e: React.FormEvent) => {
    e.preventDefault();

    var val: any = selectedValue;
    val = "tab" + (parseInt(val.charAt(val.length - 1)) + 1);

    console.log("props.formRef=", props.formRef);

    if (!props.formRef) {
      setSelectedValue(val);
      setActiveTab(val);
    } else if (validation(props.formRef) || props.formRef?.current == null) {
      setSelectedValue(val);
      setActiveTab(val);
      props.formRef?.current?.submit();
    } else {
      props.formRef?.current?.submit();
    }
  }

  const handlePrevBtnClick = () => {
    var val: any = selectedValue;
    val = "tab" + (parseInt(val.charAt(val.length - 1)) - 1)
    setSelectedValue(val);
    setActiveTab(val);
  }

  const handleNext = (e: any) => {
    // (props.formRef?.current)
    //   ? !(somefunction(e) && !somefunction3(e))
    //     ? <> {(handleNextBtnClick(e), console.log("2nd Conf"))} </>
    //     : (handleNextBtnClick(e))
    //   : ((props.classificationNameValidation === true && somefunction(e)) || (props.classificationNameValidation === true && somefunction3(e)))
    //     ? <> {(handleNextBtnClick(e), console.log("1st Conf"))} </>
    //     : (props.handleOutsideButton)
    //       ? <> {(props.handleOutsideButton(),somefunction(e), console.log("Handle Outside"))} </>
    //       : <> {(handleNextBtnClick(e), console.log("Else Here"))} </>

    //   props.classificationNameValidation === true && somefunction2(e) && handleNextBtnClick(e);
    //   /*props.classificationNameValidation === true &&*/ somefunction4(e) && handleNextBtnClick(e);
    //   props.classificationNameValidation === true && somefunction5(e) && handleNextBtnClick(e);
    //   somefunction1(e) && handleNextBtnClick(e);

    if (props.formRef?.current) {
      if (!(somefunction(e) && !somefunction3(e))) {
        handleNextBtnClick(e);
        console.log("2nd Conf");
      } else {
        handleNextBtnClick(e);
      }
    } else if (props.classificationNameValidation !== undefined && !props.classificationNameValidation) {
      // do nothing
    } else if (props.classificationNameValidation === true && (somefunction(e) || somefunction3(e) || somefunction2(e) || somefunction5(e))) {
      handleNextBtnClick(e);
      console.log("1st Conf");
    } else if (props.handleOutsideButton) {
      props.handleOutsideButton();
      somefunction(e);
      console.log("Handle Outside");
    } else {
      handleNextBtnClick(e);
      console.log("Else Here");
    }

    if (somefunction4(e) || somefunction1(e)) {
      handleNextBtnClick(e);
    }
  }

  // let customWidth = !props.overlayData.size ? overlayWidth : ''
  return (
    <FluentProvider theme={dashboardTheme}>
      <OverlayDrawer
        style={overlayHeight}
        modalType="modal"
        position={"end"}
        open={props.overlayopen}
        size={props.overlayData.size} // onOpenChange={(_, { open }) => setIsOpen(open)}
      >
        <DrawerHeader style={paddingBottom}>
          <DrawerHeaderTitle action={<Button shape="circular" appearance="subtle" aria-label="Close" icon={<Dismiss20Regular />} onClick={() => { props.setOverlayOpen(false); setTimeout(() => { setSelectedValue("tab1"); setActiveTab("tab1") }, 2000); }} />}>
            {props.overlayData.headerTitle}
          </DrawerHeaderTitle>
          {props.overlayData.headerTitle === 'Notifications' ? <></> : <Divider />}
        </DrawerHeader>

        <DrawerBody>
          {props.overlayData.isTabs &&
            <TablistComponent tabListData={props.overlayData.tabItems} saveBtnFuncs={props.saveBtnFunc} setSelectedValue={setSelectedValue} selectedValue={selectedValue} setActiveTab={setActiveTab} activeTab={activeTab} />
          }
          {props.overlayData.bodyData}
          {/* {showWarning && (
            <FluentProvider theme={dashboardTheme}>
              <p> Mandatory fields are not filled. Please check the input fields. </p>
            </FluentProvider>
          )} */}
        </DrawerBody>

        <DrawerFooter>
          <>
            {props.isNavBtn &&
              <Stack horizontal tokens={{ childrenGap: 5, padding: 5 }}>
                <StackItem>
                  {activeTab !== "tab1" &&
                    <Button shape="circular" id='prev'
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)} appearance="primary" size="small" onClick={handlePrevBtnClick}>
                      Prev
                    </Button>
                  }
                </StackItem>

                <StackItem>
                  {activeTab !== `tab${props.overlayData.tabItems ? Object.keys(props.overlayData.tabItems).length : []}` &&
                    <Button shape="circular" id='next'
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)}
                      disabled={props?.isDisabled ? props?.isDisabled : false}
                      appearance="primary"
                      size="small"
                      onClick={(e) => handleNext(e)}
                    >
                      Next
                    </Button>
                  }
                </StackItem>

                <StackItem>
                  {activeTab == `tab${props.overlayData.tabItems ? Object.keys(props.overlayData.tabItems).length : []}` &&
                    <Button shape="circular" style={{ backgroundColor: hover ? "#EF6D58" : "#03A0AB" }}
                      onMouseEnter={() => setHover(true)}
                      onMouseLeave={() => setHover(false)} appearance="primary" size="small" onClick={() => { props.saveBtnFunc(true); props?.setOverlayOpen&&props.setOverlayOpen(false); setTimeout(() => { setSelectedValue("tab1"); setActiveTab("tab1") }, 2000); }} disabled={(props.saveBtnClicked != undefined && props.saveBtnClicked) ? true : false}>
                      {props.pagename === "roles" ? "Create" : props.pagename === "approvals" ? "Approve" : "Save"}
                    </Button>
                  }
                </StackItem>
              </Stack>
            }
            {!(props?.isNavBtn) && props.overlayData.footerData}
          </>
        </DrawerFooter>
      </OverlayDrawer>
    </FluentProvider>
  );
};

export default OverLay;